import { useState, useEffect } from 'react'
import { Box, Paper } from '@material-ui/core'
import Typography from '@material-ui/core/Typography'

import FinancialDataTable from './components/FinancialDataTable'

import ApiBudgetCompliance from './api/apiBudgetCompliance'
import LoadingScreen from '../../common/LoadingScreen/components/LoadingScreen'
import FinancialSearchBar from './components/FinancialSearchBar'
import UserApi from '../User/apis'

export const BudgetCompliance = () => {
  const apiBudgetCompliance = new ApiBudgetCompliance()
  const userApi = new UserApi()

  const [financialData, setFinancialData] = useState([])
  const [isLoading, setIsLoading] = useState(true)

  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(25)
  const [totalRecords, setTotalRecords] = useState(1)

  const [orderBy, setOrderBy] = useState('Copropriété')
  const [orderDirection, setOrderDirection] = useState('ASC')

  const [searchValue, setSearchValue] = useState('')
  const [onlyCurrentUser, setOnlyCurrentUser] = useState(false)

  const [managers, setManagers] = useState([])
  const [accountants, setAccountants] = useState([])
  const [selectedUsers, setSelectedUsers] = useState([])
  const [roleSearched, setRoleSearched] = useState('')

  const handleChangePage = (newPage) => {
    setIsLoading(true)
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (newRowsPerPage) => {
    setIsLoading(true)
    setRowsPerPage(newRowsPerPage)
    setPage(0)
  }

  const handleOnChangeOrder = (newOrderBy, newOrderDirection) => {
    setIsLoading(true)
    setOrderBy(newOrderBy)
    setOrderDirection(newOrderDirection)
  }

  const handleOnChangeSearchBar = (newSearchValue) => {
    if (newSearchValue !== searchValue) {
      setIsLoading(true)
      setSearchValue(newSearchValue)
      setOnlyCurrentUser(false)
      setSelectedUsers([])
      setPage(0)
    }
  }
  const handleOnChangeCheckBox = (newOnlyCurrentUser) => {
    setIsLoading(true)
    setOnlyCurrentUser(newOnlyCurrentUser)
    setSearchValue('')
    setSelectedUsers([])
    setPage(0)
  }

  const handleOnChangeSelect = (selectedUser, selectedRole) => {
    setIsLoading(true)
    if (roleSearched !== selectedRole) setRoleSearched(selectedRole)
    setSelectedUsers(selectedUser)
    setSearchValue('')
    setOnlyCurrentUser(false)
    setPage(0)
  }

  const fetchBudgetFinancialData = async () => {
    const res = await apiBudgetCompliance.getAllCurrentYearBudgetsCompliance(
      page,
      rowsPerPage,
      orderBy,
      orderDirection,
      searchValue,
      selectedUsers,
      onlyCurrentUser
    )
    setFinancialData(res.results)
    setTotalRecords(res.total)
    setIsLoading(false)
  }

  const fetchUsersByRoles = async () => {
    const managerRes = await userApi.getUsersByRole('Gestionnaire')
    const accountantRes = await userApi.getUsersByRole('Comptable')

    setManagers(managerRes)
    setAccountants(accountantRes)
  }

  useEffect(() => {
    fetchUsersByRoles()
  }, [])

  useEffect(() => {
    // If the search value is not empty, update the page with this value
    fetchBudgetFinancialData()
  }, [
    orderBy,
    orderDirection,
    page,
    rowsPerPage,
    searchValue,
    onlyCurrentUser,
    selectedUsers,
  ])

  return (
    <Box sx={{ padding: '25px', position: 'relative' }} component={Paper}>
      <Typography
        style={{ textAlign: 'center', fontSize: '25px', marginBottom: '30px' }}
      >
        LISTE DES COPROPRIETES
      </Typography>

      <FinancialSearchBar
        onChangeSearchBar={handleOnChangeSearchBar}
        onChangeCheckBox={handleOnChangeCheckBox}
        onChangeSelect={handleOnChangeSelect}
        selectedUsers={selectedUsers}
        managers={managers}
        accountants={accountants}
        roleSearched={roleSearched}
        onlyCurrentUser={onlyCurrentUser}
      />

      <FinancialDataTable
        financialData={financialData}
        page={page}
        rowsPerPage={rowsPerPage}
        totalRecords={totalRecords}
        orderBy={orderBy}
        orderDirection={orderDirection}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
        onChangeOrder={handleOnChangeOrder}
      />

      {isLoading && <LoadingScreen text="Chargement des budgets..." />}
    </Box>
  )
}

export default BudgetCompliance
